import { useState } from "react";
import { Plus } from "lucide-react";

export default function Faq({ items, testId = "faq" }) {
  const [open, setOpen] = useState(0);
  return (
    <div data-testid={testId} className="divide-y divide-navy-700 border-y border-navy-700">
      {items.map((item, i) => {
        const isOpen = open === i;
        return (
          <div key={item.q}>
            <button
              type="button"
              onClick={() => setOpen(isOpen ? -1 : i)}
              aria-expanded={isOpen}
              className="flex w-full items-start justify-between gap-6 py-6 text-left"
            >
              <span className="font-display text-xl font-semibold leading-snug text-cream sm:text-2xl">{item.q}</span>
              <Plus
                className={`mt-1.5 h-5 w-5 shrink-0 text-gold-400 transition-transform duration-300 ${isOpen ? "rotate-45" : ""}`}
              />
            </button>
            {isOpen && <p className="-mt-2 pb-6 pr-10 text-[15px] leading-relaxed text-mist">{item.a}</p>}
          </div>
        );
      })}
    </div>
  );
}
